import React from 'react';
import PropTypes from 'prop-types';
import useSelectorCantidad from './useSelectorCantidad';
import './styles.css';

const SelectorCantidad = ({
  value,
  onChange,
  incremento,
  productoPesable,
  cantidadLimMin,
  cantidadLimMax,
}) => {
  
  const {
    handleOnIncrement,
    handleOnDecrement,
    handleOnChangeInput,
    handleOnFocusInput,
  } = useSelectorCantidad({
    value,
    onChange,
    incremento,
    cantidadLimMin,
    cantidadLimMax,
    productoPesable,
  });

  return (
    <div className='selectorCantidad'>
      <div className='btn' onClick={handleOnDecrement}>
        -
      </div>
        <input 
          //type='text' 
          inputMode="numeric"
          type="number" 
          min="0" 
          step="1"
          className='cantidad cantidadInput' 
          value={value}
          onChange={handleOnChangeInput}
          onFocus={handleOnFocusInput}
        />                  
      <div className='btn' onClick={handleOnIncrement}>
        +
      </div>
    </div>
  );
};

SelectorCantidad.defaultProps = {
  value: 0,
  onChange: () => {},
  incremento: undefined,
  productoPesable: false,
  cantidadLimMin: undefined,
  cantidadLimMax: undefined,
};

SelectorCantidad.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  incremento: PropTypes.number,
  productoPesable: PropTypes.bool,
  cantidadLimMin: PropTypes.number,
  cantidadLimMax: PropTypes.number,
};

export default SelectorCantidad;
